import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt } from '@fortawesome/pro-solid-svg-icons'

import {
  Box, InputSearch, Link, Text,
} from '@domain-group/suit-theme'

import { digObject } from '@domain-group/javascript-utils'

import { useSetState } from '@domain-group/react-hooks'

import api from '@functions/api'

import type { AgencyModel } from '@models/agency'
import type { UserModel } from '@models/user'

type Results = {
  groups: { key: string, items: any, title: string }[],
}

const mapResults = (results: Results) => ({
  groups: [
    {
      key: 'results',
      // @ts-expect-error TS2339
      items: results.map((result: { id: number, full_name: string }) => ({
        id: result.id,
        key: result.id,
        text: `${result.full_name} ID #${result.id}`,
      })),
      title: 'Realbase Users',
    },
  ],
})

type DefaultState = {
  email: string,
  loading: boolean,
  results?: Results | null,
}

type SearchParams = {
  endpoint: string,
  setState: (payload: Partial<DefaultState>) => void,
  requestOptions?: object,
}

const search = (params: SearchParams) => {
  const { endpoint, setState, requestOptions } = params
  setState({ loading: true, results: null })

  api(endpoint, requestOptions)
    .then(({ data }: { data: object }) => ({ success: true, data }))
    .catch(errors => ({ success: false, errors }))
    // @ts-expect-error TS2339
    .then(({ success, data }) => {
      if (success){
        setState({
          loading: false,
          results: mapResults(data),
        })
        return
      }

      setState({
        loading: false,
        results: null,
      })
    })
}

const defaultState: DefaultState = {
  email: '',
  loading: false,
  results: null,
}

type RealbaseIdProps = {
  agency: Partial<AgencyModel>,
  callbacks: {
    selectItem: (item: object) => void,
  },
  userForm: {
    entityState: Partial<UserModel>,
  },
}

const RealbaseId = (props: RealbaseIdProps) => {
  const {
    agency,
    callbacks: { selectItem },
    userForm: {
      entityState: { data },
    },
  } = props

  const [state, setState] = useSetState(defaultState)
  const { email, results } = state

  const realbaseId = digObject(data, 'external_ids.realbase')

  return (
    <>
      {!realbaseId && (
        <InputSearch
          callbacks={{
            selectItem: item => selectItem(item?.id),
          }}
          filterItems={false}
          // @ts-expect-error TS18047
          onChange={(e: KeyboardEvent) => setState({ email: e.target.value })}
          // @ts-expect-error TS2322
          results={results}
          serverSearch={() => search({
            endpoint: 'users/fetch_from_external_platform',
            setState,
            requestOptions: { external_platform_key: 'realbase', email, brand_id: agency.brand_id },
          })}
          placeholder="Search user email"
          value={email}
        />
      )}

      {realbaseId && (
        <Box alignItems="center" fontSize="small" height={38} padding="medium" pointerEvents="auto" variant="white">
          <Text color="bodyFontColor" variant="twoLineEllipsis">
            {realbaseId}
          </Text>

          <Box marginLeft="auto" width="auto">
            {/*
             // @ts-expect-error TS2345 */}
            <Link greyLink onClick={() => selectItem(null)}>
              <FontAwesomeIcon icon={faTrashAlt} />
            </Link>
          </Box>
        </Box>
      )}
    </>
  )
}

export default RealbaseId
